module.exports = __webpack_public_path__ + "assets/img/d5183bdb926dc423e59f129b53bd16e2.svg";